<template>
  <ed-modal
    :show="show"
    :title="title"
    primary-button="Save"
    secondary-button="Cancel"
    @close="onClose"
    @validate="onSave"
    :validation="validation"
    :primaryButtonDisabled="saveButtonDisabled"
    :closeOnEsc="true"
    name='add_fees_discounts'
  >
    <div class="content" slot="body">
      <ed-form class="col-md-12 no-pad" :submit-visible="false">
        <div class="row">
          <div class="col-md-12">
            <ed-select
              field-label="Category"
              :placeholder="categoryPlaceholder"
              :options="categories"
              required="required"
              label="text"
              track-by="text"
              group-label='label'
              group-values='options'
              v-model="formData.draftItem.category"
              @select="categorySelected($event)"
              :error="doDisplayCategoryError"
              :helptip-header="doDisplayCategoryError ? 'Error' : ''"
              :helptip-body="doDisplayCategoryError ? 'Please select a category' : ''"
              name='category'
            />
          </div>
        </div>

        <div class="row" v-if="showOneBusinessUnit">
            <label class="col-md-4">Business Unit</label>
            <span class="col-md-8 small" name='one_bu_name'>{{businessUnit.name}}</span>
        </div>
        <div class="row" v-if="showBusinessUnits">
          <div class="col-md-12">
            <ed-select
              field-label="Business Unit"
              placeholder="Select business unit"
              :options="businessUnits"
              required="required"
              label="name"
              track-by="key"
              v-model="formData.draftItem.businessUnit"
              @select="businessUnitSelected($event)"
              :error="doDisplayBusinessUnitError"
              :helptip-header="doDisplayBusinessUnitError ? 'Error' :''"
              :helptip-body="doDisplayBusinessUnitError ? 'Please select a Business Unit' : ''"
              name='business_units'
            />
          </div>
        </div>

        <div class="row" v-if="showOneCostCenter">
          <label class="col-md-4">Cost Center</label>
          <span class="col-md-8 small" name='one_cc_name'>
            {{ costCenter.name ? getCostCenterName(costCenter) : costCenter.code }}
          </span>
        </div>
        <div class="row" v-if="showCostCenters">
          <div class="col-md-12">
            <ed-select
              field-label="Cost Center"
              placeholder="Select a Cost Center"
              :options="costCenters"
              required="required"
              label="name"
              track-by="code"
              :customLabel='getCostCenterName'
              v-model="formData.draftItem.costCenter"
              @select="costCenterSelected($event)"
              :error="doDisplayCostCenterError"
              :helptip-header="doDisplayCostCenterError ? 'Error' : ''"
              :helptip-body="doDisplayCostCenterError ? 'Please select a Cost Center' : ''"
              name='cost_centers'
            />
          </div>
        </div>

        <div class="row" v-if="showOneCostCenterWithBusinessUnit">
          <label class="col-md-4">Business Unit and Cost Center</label>
          <span class="col-md-8 small" name='one_bu_cc_pair_name'>{{businessUnitsWithCostCenter.name}}</span>
        </div>

        <div class="row" v-if="showMixCostCentersWithBusinessUnits">
          <div class="col-md-12">
            <ed-select
              field-label="Business Unit and Cost Center"
              placeholder="Select business unit and cost center pair"
              :options="businessUnitsWithCostCenters"
              required="required"
              label="name"
              track-by="key"
              v-model="formData.draftItem.pairedBusinessUnitAndCostCenter"
              @select="businessUnitWithCostCenter($event)"
              :error="doDisplayMixCostCenterWithBusinessUnitError"
              :helptip-header="doDisplayMixCostCenterWithBusinessUnitError ? 'Error' : ''"
              :helptip-body="doDisplayMixCostCenterWithBusinessUnitError ? 'Please select a Business Unit with Cost Center' : ''"
              name='bu_cc_pairs'
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <ed-textarea
              field-label="Description"
              v-model="formData.draftItem.description"
              placeholder
              name='description'
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <custom-fields
              :endpoint="api.$.invoice.i2p.itemCustomFields"
              :queryParameters="{invoiceId: model.PaymentInvoiceId, divisionId: model.DivisionID}"
              :values="itemCustomFields"
              ref="feeCustomFieldsRef">
            </custom-fields>
          </div>
        </div>

        <div class="row" v-if="formData.draftItem.category.amountTypes !== null">
          <div class="col-md-8">
            <ed-select
              field-label="Amount"
              :options="amountTypes"
              required="required"
              label="text"
              track-by="amountType"
              v-model="formData.draftItem.amountType"
              @select="amountTypeSelected($event)"
              :error="doDisplayAmountTypeError"
              :helptip-header="doDisplayAmountTypeError ? 'Error' : ''"
              :helptip-body="doDisplayAmountTypeError ? 'Please select an amount type' : ''"
              name='amount_types'
            />
          </div>
          <div class="col-md-4">
            <ed-input v-if="enterAmountSelected"
              :empty-field-label="true"
              type="money"
              :currency="currency"
              amount
              autoselect
              v-model="formData.draftItem.amountTypeValue"
              name="amount_selected"
            />
            <ed-input v-else
              :empty-field-label="true"
              amount
              symbol="%"
              autoselect
              v-model="formData.draftItem.amountTypeValue"
              name="amount_percent"
            />
          </div>
        </div>
      </ed-form>
    </div>
  </ed-modal>
</template>
<script>
/* eslint spec-file: 0 */

import LineItemStore from './LineItemStore.js'
import itemTypes from '../../models/itemTypes'
import customFields from '@/core/components/Form/customFields.vue'
import { EventBus } from '@/event-bus'

export default {
  name: 'AddFeesDiscountItem' /* mandatory field */,

  components: {
    customFields
  },

  props: {
    programId: Number,
    eventId: String,
    dependencies: Object,
    eventHub: Object,
    model: Object
  },

  created() {
    let isEdit = this.model.draftItem !== null && typeof this.model.draftItem !== 'undefined'

    this.store()
      .getFeesAndDiscountItemData(
        this.model.programId,
        this.model.invoiceId)
      .then(response => {
        this.bindCategoriesandAmountTypes(response.data)
        let action = 'Add'

        if (this.model.draftItem) {
          let category = {}
          this.categories.forEach(option => {
            if (option.options.filter(x => x.text === this.model.draftItem.name)[0] != null) {
              category = option.options.filter(x => x.text === this.model.draftItem.name)[0]
            }
          })
          this.model.draftItem.category = category

          this.amountTypes = this.amountByCategory[this.model.draftItem.name]
          let amountTypeModel = this.amountTypes && this.amountTypes.filter(
            x => +x.amountType === +this.model.draftItem.amountTypeId
          )[0]

          if (amountTypeModel) {
            this.model.draftItem.amountType.amountType = amountTypeModel.amountType
            this.model.draftItem.amountType.text = amountTypeModel.text
          }
          this.formData.draftItem = this.model.draftItem

          this.formData.draftItem.isFeeDiscountItem = true
          action = 'Edit'
        }

        this.title = action + ' Fee or Discount Item'

        this.bindCostCenterAndBusinessUnit(response.data, isEdit)
      })
  },

  data() {
    return {
      formData: {
        draftItem: this.getEmptyDraftItem()
      },
      amountByCategory: {},
      show: true,
      saveButtonDisabled: false,
      validation: true,
      title: 'Add Fee or Discount Item',
      amountTypes: [],
      categories: [],
      costCenters: [],
      costCenter: '',
      businessUnits: [],
      businessUnit: '',
      businessUnitsWithCostCenters: [],
      businessUnitsWithCostCenter: '',

      showOneCostCenter: false,
      showCostCenters: false,
      showOneBusinessUnit: false,
      showBusinessUnits: false,
      showOneCostCenterWithBusinessUnit: false,
      showMixCostCentersWithBusinessUnits: false,

      isCategorySelected: false,
      doDisplayCategoryError: false,

      isAmountTypeSelected: false,
      doDisplayAmountTypeError: false,

      isCostCenterSelected: false,
      doDisplayCostCenterError: false,

      isBusinessUnitSelected: false,
      doDisplayBusinessUnitError: false,

      isMixCostCenterWithBusinessUnitSelected: false,
      doDisplayMixCostCenterWithBusinessUnitError: false
    }
  },

  computed: {
    enterAmountSelected() {
      return this.formData.draftItem.amountType.text === 'Enter Amount'
    },
    currency() {
      return this.model.currency.code
    },
    categoryPlaceholder() {
      return 'Select Tax/Fee/Other line item'
    },
    itemCustomFields() {
      return this.model && this.model.draftItem && this.model.draftItem.customFields || []
    }
  },

  methods: {
    getCostCenterName(option, label) {
      return option.name
              ? option.name.indexOf(option.code) === -1
                                                      ? option.code + ' (' + option.name + ')'
                                                      : option.name
              : option.code
    },
    onClose() {
      EventBus.$emit('onCloseAddFeeOrDiscountItem', {})
      this.show = false
    },

    getEmptyDraftItem() {
      return {
        category: {},
        businessUnit: {},
        costCenter: {},
        pairedBusinessUnitAndCostCenter: '',
        costCenterAndBusinessUnit: {},
        description: '',
        amountType: {},
        amount: ''
      }
    },

    onSave() {
      if (!this.isValid()) return

      // update custom line item category
      let category = this.formData.draftItem.category
      if (category && category.key) {
        this.formData.draftItem.feeTypeId = null
        this.formData.draftItem.taxTypeId = null
        this.formData.draftItem.customTypeId = null

        if (category.key.indexOf('fee') !== -1) {
          this.formData.draftItem.feeTypeId = Number(category.key.replace('fee', ''))
        }
        if (category.key.indexOf('tax') !== -1) {
          this.formData.draftItem.taxTypeId = Number(category.key.replace('tax', ''))
        }
        if (category.key.indexOf('oth') !== -1) {
          this.formData.draftItem.customTypeId = Number(category.key.replace('oth', ''))
        }
      }

      // update allocation
      if (typeof this.formData.draftItem.costCenterAndBusinessUnit === 'undefined') {
        this.formData.draftItem.costCenterAndBusinessUnit = {}
      }

      if (this.showOneCostCenter) {
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = this.costCenter.key
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.costCenter.code
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.costCenter.name
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.costCenter.costCenterId
      } else if (this.formData.draftItem.costCenter) {
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId = this.formData.draftItem.costCenter.key
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo = this.formData.draftItem.costCenter.code
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterName = this.formData.draftItem.costCenter.name
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.formData.draftItem.costCenter.costCenterId
      }

      if (this.showOneBusinessUnit) {
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.businessUnit.name
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnit.businessUnitId
      } else if (this.formData.draftItem.businessUnit) {
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName = this.formData.draftItem.businessUnit.name
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.formData.draftItem.businessUnit.businessUnitId
      }

      if (this.showOneCostCenterWithBusinessUnit) {
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = true

        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey = this.businessUnitsWithCostCenter.key
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName = this.businessUnitsWithCostCenter.name
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId = +this.businessUnitsWithCostCenter.costCenterId
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId = +this.businessUnitsWithCostCenter.businessUnitId
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId =
          +this.businessUnitsWithCostCenter.programBusinessUnitAndCostCenterId
      } else if (this.formData.draftItem.pairedBusinessUnitAndCostCenter) {
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = true

        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey =
          this.formData.draftItem.pairedBusinessUnitAndCostCenter.key
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName =
          this.formData.draftItem.pairedBusinessUnitAndCostCenter.name
        this.formData.draftItem.costCenterAndBusinessUnit.costCenterId =
          +this.formData.draftItem.pairedBusinessUnitAndCostCenter.costCenterId
        this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId =
          +this.formData.draftItem.pairedBusinessUnitAndCostCenter.businessUnitId
        this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId =
          +this.formData.draftItem.pairedBusinessUnitAndCostCenter.programBusinessUnitAndCostCenterId
      } else {
        this.formData.draftItem.useBusinessUnitAndCostCenterMapping = false
      }

      this.formData.draftItem.customFields = this.$refs.feeCustomFieldsRef.getFields()

      if (!this.formData.draftItem.amountType ||
        !this.formData.draftItem.amountType.amountType) {
        this.formData.draftItem.amountType = {
          amountType: 1 // default amount type
        }
      }

      if (!this.formData.draftItem.amountTypeValue) {
        this.formData.draftItem.amountTypeValue = 0
      }

      EventBus.$emit('onSaveFeeOrDiscountItem', {
        data: this.formData.draftItem,
        eventId: this.eventId
      })

      this.show = false
    },

    isValid() {
      var result = true
      if (
        !this.isCategorySelected === true &&
        this.formData.draftItem.category.text === undefined
      ) {
        this.doDisplayCategoryError = true
        result = false
      }

      if (
        this.formData.draftItem.category.amountTypes !== null &&
        !this.isAmountTypeSelected === true &&
        this.formData.draftItem.amountType.amountType === undefined
      ) {
        this.doDisplayAmountTypeError = true
        result = false
      }

      if (this.showCostCenters === true) {
        if (
          this.isCostCenterSelected === false &&
          !(this.formData.draftItem &&
          this.formData.draftItem.costCenter && this.formData.draftItem.costCenter !== null &&
          this.formData.draftItem.costCenter.key)
        ) {
          this.doDisplayCostCenterError = true
          result = false
        }
      }

      if (this.showBusinessUnits === true) {
        if (this.isBusinessUnitSelected === false && this.formData.draftItem.businessUnit.key) {
          this.doDisplayBusinessUnitError = true
          result = false
        }
      }

      if (this.showMixCostCentersWithBusinessUnits) {
        if (this.isMixCostCenterWithBusinessUnitSelected === false &&
            !(this.formData.draftItem &&
          this.formData.draftItem.pairedBusinessUnitAndCostCenter && this.formData.draftItem.pairedBusinessUnitAndCostCenter !== null)) {
          this.doDisplayMixCostCenterWithBusinessUnitError = true
          result = false
        }
      }

      if (!this.$refs.feeCustomFieldsRef.validate()) {
        result = false
      }

      return result
    },

    store() {
      return new LineItemStore(this.api)
    },

    groupItemsByType(items, type, map) {
      let groups = []
      let groupedItems = {}
      let mappedGroupedItems = []

      items.forEach(item => {
        let groupName = item[type]
        if (!~groups.indexOf(groupName)) {
          groups.push(groupName)
          groupedItems[groupName] = []
        }
        groupedItems[groupName].push(item)
      })

      if (typeof map === 'object') {
        Object.keys(groupedItems).forEach(key => {
          if (map[key]) {
            mappedGroupedItems.push({
              label: map[key],
              options: groupedItems[key]
            })
          } else {
            mappedGroupedItems.filter(item => item.label === map[map.default])[0]
              .options
              .push(...groupedItems[key])
          }
        })

        return mappedGroupedItems
      }

      return groupedItems
    },

    bindCategoriesandAmountTypes(data) {
      if (data.feesAndTaxes !== null && data.feesAndTaxes !== undefined) {
        for (var i = 0; i < data.feesAndTaxes.length; i++) {
          var category = data.feesAndTaxes[i]
          this.categories.push(category)
          this.amountByCategory[category.text] = category.amountTypes
        }
        this.categories = this.groupItemsByType(this.categories, 'itemType', itemTypes)
      }
    },

    categorySelected(e) {
      this.amountTypes = this.amountByCategory[e.text]

      if (this.amountTypes) {
        if (this.amountTypes.length === 1) {
          let model = {
            amountType: this.amountTypes[0].amountType,
            text: this.amountTypes[0].text
          }
          this.formData.draftItem.amountType = model
          this.amountTypeSelected()
        } else {
          let amountTypeEnterAmount = this.amountTypes.filter(item => item.text === 'Enter Amount')

          if (amountTypeEnterAmount && amountTypeEnterAmount.length > 0) {
            let model = {
              amountType: amountTypeEnterAmount[0].amountType,
              text: amountTypeEnterAmount[0].text
            }
            this.formData.draftItem.amountType = model
            this.amountTypeSelected()
          }
        }
      }

      this.isCategorySelected = true
      this.doDisplayCategoryError = false

      this.formData.draftItem.category = e
    },

    amountTypeSelected(e) {
      this.isAmountTypeSelected = true
      this.doDisplayAmountTypeError = false
      if (e) {
        this.formData.draftItem.amountType.amountType = e.amountType
        this.formData.draftItem.amountType.text = e.text
      }
    },

    costCenterSelected(e) {
      if (this.showCostCenters) {
        this.isCostCenterSelected = true
        this.doDisplayCostCenterError = false
        this.formData.draftItem.costCenterAndBusinessUnit = {
          costCenterNo: e.code,
          costCenterName: e.name,
          costCenterId: +e.costCenterId
        }
      }
    },

    businessUnitSelected(e) {
      if (this.showBusinessUnits) {
        this.isBusinessUnitSelected = true
        this.doDisplayBusinessUnitError = false
        this.formData.draftItem.costCenterAndBusinessUnit = {
          businessUnitName: e.name,
          businessUnitId: +e.businessUnitId
        }
      }
    },

    businessUnitWithCostCenter(e) {
      if (this.showMixCostCentersWithBusinessUnits) {
        this.isMixCostCenterWithBusinessUnitSelected = true
        this.doDisplayMixCostCenterWithBusinessUnitError = false
      }
    },

    bindCostCenterAndBusinessUnit(data, isEdit) {
      if (data.costCentersAndBusinessUnit) {
        let costCenters = data.costCentersAndBusinessUnit.costCenters
        let businessUnits = data.costCentersAndBusinessUnit.businessUnits
        let mixedCostCentersAndBusinessUnits = data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits

        if (
          mixedCostCentersAndBusinessUnits !== null &&
          mixedCostCentersAndBusinessUnits !== undefined &&
          mixedCostCentersAndBusinessUnits.length > 0
        ) {
          if (mixedCostCentersAndBusinessUnits.length === 1) {
            this.businessUnitsWithCostCenter =
              mixedCostCentersAndBusinessUnits[0]

            this.formData.draftItem.mixedCostCentersAndBusinessUnits =
              mixedCostCentersAndBusinessUnits[0]

            this.showOneCostCenter = false
            this.showCostCenters = false
            this.showOneBusinessUnit = false
            this.showBusinessUnits = false
            this.showOneCostCenterWithBusinessUnit = true
            this.showMixCostCentersWithBusinessUnits = false

            if (!isEdit) {
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey =
                this.businessUnitsWithCostCenter.key
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName =
                this.businessUnitsWithCostCenter.name
              this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId =
                +this.businessUnitsWithCostCenter.businessUnitId
              this.formData.draftItem.costCenterAndBusinessUnit.costCenterId =
                +this.businessUnitsWithCostCenter.costCenterId
              this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId =
                +this.businessUnitsWithCostCenter.programBusinessUnitAndCostCenterId
            } else {
              this.formData.draftItem.pairedBusinessUnitAndCostCenter = {
                key: this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitKey,
                name: this.formData.draftItem.costCenterAndBusinessUnit.costCenterAndBusinessUnitName,
                businessUnitId: +this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId,
                costCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.costCenterId,
                programBusinessUnitAndCostCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.programBusinessUnitAndCostCenterId
              }
            }
          } else {
            this.businessUnitsWithCostCenters = mixedCostCentersAndBusinessUnits

            if (
              this.formData.draftItem.costCenterAndBusinessUnit !== undefined
            ) {
              this.formData.draftItem.pairedBusinessUnitAndCostCenter = this.businessUnitsWithCostCenters.filter(
                businessUnitWithCostCenter =>
                  businessUnitWithCostCenter.key ===
                  this.formData.draftItem.costCenterAndBusinessUnit
                    .costCenterAndBusinessUnitKey
              )
              if (this.formData.draftItem.pairedBusinessUnitAndCostCenter) {
                this.formData.draftItem.pairedBusinessUnitAndCostCenter =
                  this.formData.draftItem.pairedBusinessUnitAndCostCenter[0]
              }
            }

            this.showOneCostCenter = false
            this.showCostCenters = false
            this.showOneBusinessUnit = false
            this.showBusinessUnits = false
            this.showOneCostCenterWithBusinessUnit = false
            this.showMixCostCentersWithBusinessUnits = true
          }
        } else {
          if (
            costCenters !== null &&
            costCenters !== undefined &&
            costCenters.length > 0
          ) {
            if (costCenters.length === 1) {
              this.costCenter = costCenters[0]
              this.formData.draftItem.costCenter = costCenters[0]

              this.showOneCostCenter = true
              this.showCostCenters = false
              this.showOneCostCenterWithBusinessUnit = false
              this.showMixCostCentersWithBusinessUnits = false

              if (!isEdit) {
                this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo =
                  this.costCenter.key
                this.formData.draftItem.costCenterAndBusinessUnit.costCenterName =
                  this.costCenter.name
                this.formData.draftItem.costCenterAndBusinessUnit.costCenterId =
                  +this.costCenter.costCenterId
              } else {
                this.formData.draftItem.costCenter = {
                  key: this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo,
                  name: this.formData.draftItem.costCenterAndBusinessUnit.costCenterName,
                  costCenterId: +this.formData.draftItem.costCenterAndBusinessUnit.costCenterId
                }
              }
            } else {
              this.costCenters = costCenters

              this.showOneCostCenter = false
              this.showCostCenters = true
              this.showOneCostCenterWithBusinessUnit = false
              this.showMixCostCentersWithBusinessUnits = false

              if (
                this.formData.draftItem.costCenterAndBusinessUnit !==
                undefined
              ) {
                this.formData.draftItem.costCenter = costCenters.filter(
                  costCenter =>
                    costCenter.key ===
                      this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo
                )
                // array to object
                if (this.formData.draftItem.costCenter) {
                  this.formData.draftItem.costCenter = this.formData.draftItem.costCenter[0]
                }
                if (this.formData.draftItem.costCenter &&
                  this.formData.draftItem.costCenterAndBusinessUnit.costCenterNo) {
                  this.isCostCenterSelected = true
                }
              }
            }
          }

          if (
            businessUnits !== null &&
            businessUnits !== undefined &&
            businessUnits.length > 0
          ) {
            if (businessUnits.length === 1) {
              this.businessUnit = businessUnits[0]
              this.formData.draftItem.businessUnit = businessUnits[0]

              this.showOneBusinessUnit = true
              this.showBusinessUnits = false
              this.showOneCostCenterWithBusinessUnit = false
              this.showMixCostCentersWithBusinessUnits = false

              if (!isEdit) {
                this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName =
                  this.businessUnit.name
                this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId =
                  +this.businessUnit.businessUnitId
              } else {
                this.formData.draftItem.businessUnit = {
                  key: this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName,
                  name: this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName,
                  businessUnitId: +this.formData.draftItem.costCenterAndBusinessUnit.businessUnitId
                }
              }
            } else {
              this.businessUnits = businessUnits

              this.showOneBusinessUnit = false
              this.showBusinessUnits = true
              this.showOneCostCenterWithBusinessUnit = false
              this.showMixCostCentersWithBusinessUnits = false

              if (this.formData.draftItem.costCenterAndBusinessUnit !== undefined) {
                this.formData.draftItem.businessUnit = businessUnits.filter(
                  bu => bu.key === this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName
                )
                // array to object
                if (this.formData.draftItem.businessUnit) {
                  this.formData.draftItem.businessUnit = this.formData.draftItem.businessUnit[0]
                }
                if (this.formData.draftItem.businessUnit &&
                  this.formData.draftItem.costCenterAndBusinessUnit.businessUnitName) {
                  this.isBusinessUnitSelected = true
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/I2P/dialogs/LineItem/AddFeesDiscountItem.vue